module.exports = __webpack_public_path__ + "img/HX.b44b5b98.png";